import { isEmpty } from '@chegg/utils';
import { getYifteeMop } from './helpers/getYifteeMop';
import { submitPaymentMethod } from './helpers/submitPaymentMethod';
import { verifyExistingMop } from './helpers/verifyExistingMop';
import { submitUpiPaymentMethod } from './helpers/submitUpiPaymentMethod';

/**
 *  When the price summary is updated, PM performs several actions
 * 1. Update the price summary used in the config.
 * 2. Recalculate the supported payment methods
 * 3. Strip out any invalid payment methods from redux
 * 4. Depending on the number of MOPs leftover, set the application mode
 * @param state
 * @param command
 * @param dispatch
 */
export var fetchPaymentMethodCommand = function fetchPaymentMethodCommand(params) {
  var state = params.state,
    dispatch = params.dispatch;
  var appMode = state.appMode,
    config = state.config,
    mopOnFile = state.mopOnFile,
    payment = state.payment;
  var isFetchPaymentMethodEnabled = appMode.isFetchPaymentMethodEnabled,
    mode = appMode.mode;
  var yifteeMop = mopOnFile.yifteeMop,
    selectedMop = mopOnFile.selectedMop,
    venmo = mopOnFile.venmo;
  var shouldValidateExistingMopsZipcodes = config.shouldValidateExistingMopsZipcodes,
    debug = config.debug,
    rioNamespace = config.rioNamespace,
    paymentErrorModal = config.paymentErrorModal,
    upi = config.upi;
  var deviceData = payment.deviceData,
    isZipMandatory = payment.billingAddress.isZipMandatory;
  var mop;
  if (config.yiftee.yifteeCoveringFull && yifteeMop) {
    mop = getYifteeMop({
      mopOnFile: mopOnFile,
      payment: payment,
      dispatch: dispatch,
      isZipMandatory: isZipMandatory
    });
    if (!mop) return;
  } else {
    mop = selectedMop;
  }
  //If the user has no existing MOPs, try to submit the form
  if (isEmpty(mop)) {
    if (upi) {
      submitUpiPaymentMethod(dispatch);
      return;
    }
    submitPaymentMethod(dispatch, mode, venmo);
  } else {
    verifyExistingMop({
      isFetchPaymentMethodEnabled: isFetchPaymentMethodEnabled,
      dispatch: dispatch,
      shouldValidateExistingMopsZipcodes: shouldValidateExistingMopsZipcodes,
      selectedMop: mop,
      deviceData: deviceData,
      debug: debug,
      rioNamespace: rioNamespace,
      paymentErrorModal: paymentErrorModal
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/CommandState/commands/fetchPaymentMethodCommand.js
// module id = 4404
// module chunks = 11